module.exports = __webpack_public_path__ + "static/media/no-experiments.a1bbaadb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/no-experiments.svg
// module id = 2541
// module chunks = 0